import { useMemo } from 'react';
import { useFormContext } from 'react-hook-form';
import {
    EXPENSE_RESOURCES,
    RESOURCES_TOTAL,
    SUBTOTAL,
    IExpense,
} from './expense-form';
import { isNumber, round } from '../../../../../../helpers';
import { useCalculateExpenseTotal } from './use-calculate-expense-total';

export function useCalculateExpenseResourcesTotal() {
    const rx = useFormContext();
    const { calculateExpenseTotal } = useCalculateExpenseTotal();
    const calculateExpenseResourcesTotal = useMemo(() => {
        return () => {
            const expenseResources = rx.getValues(
                EXPENSE_RESOURCES,
            ) as IExpense['expense_resources'];
            const subtotal = expenseResources.reduce((acc, resource) => {
                return (
                    acc +
                    (isNumber(Number(resource.units)) &&
                    isNumber(Number(resource.unit_price))
                        ? Number(resource.units) * Number(resource.unit_price)
                        : 0)
                );
            }, 0);

            const total = round(subtotal);
            rx.setValue(RESOURCES_TOTAL, total);
            // Subtotal is now derived from the product lines — mirror the
            // resources total into it and cascade to the grand total (which
            // adds tax and subtracts retentions).
            rx.setValue(SUBTOTAL, total, { shouldValidate: true });
            calculateExpenseTotal();
        };
    }, [rx, calculateExpenseTotal]);
    return { calculateExpenseResourcesTotal };
}
